import React from 'react';

import { Wrapper, Input, Unit } from './wrapper';

type Props = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  value: string;
  placeholder: string;
  label: string;
  bordered?: boolean;
  unit?: string;
  inputMode?: string;
  pattern?: string;
};

const InputText = ({
  placeholder,
  label,
  bordered,
  unit,
  value,
  id,
  name,
  inputMode,
  pattern,
  onChange,
  onBlur,
  onKeyDown,
}: Props) => (
  <Wrapper $bordered={bordered}>
    <Input
      placeholder={placeholder}
      value={value}
      id={id}
      aria-label={label}
      name={name}
      onChange={onChange}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      inputMode={inputMode}
      pattern={pattern}
    />
    {unit && <Unit>{unit}</Unit>}
  </Wrapper>
);

export default InputText;
